"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _reselect = require("reselect");

var _isPropertyChanged = _interopRequireDefault(require("./isPropertyChanged"));

var _createNumberOfChangesSelector = _interopRequireDefault(require("./createNumberOfChangesSelector"));

var _createSelectorsForProperties = _interopRequireDefault(require("./createSelectorsForProperties"));

var _createAnyChangesSelector = _interopRequireDefault(require("./createAnyChangesSelector"));

var _default = function _default(_ref) {
  var stagedSelector = _ref.stagedSelector,
      domainSelector = _ref.domainSelector,
      properties = _ref.properties;
  var stagedSelectors = (0, _createSelectorsForProperties.default)({
    selector: stagedSelector,
    properties: properties
  });
  var domainSelectors = (0, _createSelectorsForProperties.default)({
    selector: domainSelector,
    properties: properties
  });
  var anyChanges = (0, _createAnyChangesSelector.default)({
    properties: properties,
    currentSelector: domainSelector,
    nextSelector: stagedSelector
  });
  var numberOfChanges = (0, _createNumberOfChangesSelector.default)({
    properties: properties,
    currentSelector: domainSelector,
    nextSelector: stagedSelector
  });

  var isChanged = function isChanged(property) {
    return (0, _reselect.createSelector)([domainSelector, stagedSelector], function (current, staged) {
      if (current) {
        if (typeof property === "string") {
          return (0, _isPropertyChanged.default)(current.get(property), staged.get(property));
        } else if ((0, _typeof2.default)(property) === "object") {
          return (0, _isPropertyChanged.default)(current.get(property.key), staged.get(property.key));
        }
      }

      return false;
    });
  };

  var getStagedProperty = function getStagedProperty(property) {
    return stagedSelectors[property];
  };

  var getStagedNestedProperty = function getStagedNestedProperty(propertyPath) {
    return stagedSelectors[propertyPath.join("/")];
  };

  var getDomainProperty = function getDomainProperty(property) {
    return domainSelectors[property];
  };

  var getStagedOrderedMapPropertyAsArray = function getStagedOrderedMapPropertyAsArray(property) {
    return (0, _reselect.createSelector)([getStagedProperty(property)], function (orderedMap) {
      return orderedMap ? orderedMap.valueSeq().toArray() : [];
    });
  };

  return {
    getStagedProperty: getStagedProperty,
    getStagedNestedProperty: getStagedNestedProperty,
    getStagedOrderedMapPropertyAsArray: getStagedOrderedMapPropertyAsArray,
    getDomainProperty: getDomainProperty,
    numberOfChanges: numberOfChanges,
    anyChanges: anyChanges,
    isChanged: isChanged
  };
};

exports.default = _default;
module.exports = exports.default;